import { render } from "./LocalDataTable.vue?vue&type=template&id=b1d1be36&scoped=true"
import script from "./LocalDataTable.vue?vue&type=script&lang=js"
export * from "./LocalDataTable.vue?vue&type=script&lang=js"

import "./LocalDataTable.vue?vue&type=style&index=0&id=b1d1be36&scoped=true&lang=css"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1d1be36"]])

export default __exports__